module.exports = __webpack_public_path__ + "img/daylight_1.d8c99344.png";